import React, { FC } from 'react';
import { Modal } from './Modal';

export const Error: FC<{ error?: string }> = ({ error }) =>
  error ? <Modal>{error}</Modal> : null;
